import { useTranslation } from "react-i18next";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export interface SummaryItem {
  label: string;
  value: string;
  /** Qiymat rangi (CSS token). Berilmasa — oddiy matn rangi. */
  color?: string;
}

/**
 * Ochiq sahifa bo'yicha qisqa yig'indi.
 *
 * Kartochka EMAS, bitta qator: bu raqamlar sahifaning maqsadi emas,
 * jadvalning izohi. Oltita kartochka jadvalni ekrandan pastga surib
 * yuborardi, holbuki admin bu sahifaga jadval uchun keladi.
 *
 * "Shu sahifada" yozuvi ataylab: bu ro'yxatning JORIY sahifasi
 * bo'yicha hisob, butun bazaniki emas. Umumiy yig'indini brauzerda
 * hisoblab bo'lmaydi — buning uchun alohida so'rov kerak, va
 * belgisiz raqam adminni noto'g'ri xulosaga olib borardi.
 */
export function PageSummary({
  items,
  isLoading,
  className,
}: Readonly<{ items: SummaryItem[]; isLoading?: boolean; className?: string }>) {
  const { t } = useTranslation();

  if (isLoading) return <Skeleton className={cn("h-9 w-72 rounded-lg", className)} />;
  if (items.length === 0) return null;

  return (
    <div
      className={cn(
        "bg-muted/50 border-border/60 inline-flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg border px-3 py-1.5",
        className,
      )}
    >
      <span className="text-muted-foreground/70 text-[11px] tracking-wide uppercase">
        {t("table.onThisPage")}
      </span>

      {items.map(item => (
        <span key={item.label} className="inline-flex items-baseline gap-1.5 text-xs">
          <span className="text-muted-foreground">{item.label}</span>
          <span className="font-semibold tabular-nums" style={{ color: item.color }}>
            {item.value}
          </span>
        </span>
      ))}
    </div>
  );
}
